import { Box, Divider } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { TOptions } from "i18next";
import { BestPracticeCheckFindingType, BestPracticeCheckViewModel } from "@common/components/bestPracticeCheckDialog/BestPracticeCheckDialog.types.ts";

interface SummaryStatsBarProps {
    result: BestPracticeCheckViewModel;
    getFindingTypeColor: (findingType: BestPracticeCheckFindingType) => string;
    translateString: (key: string, options?: TOptions | string) => string;
    selectedFindingType: BestPracticeCheckFindingType | undefined;
    onFindingTypeClick: (findingType: BestPracticeCheckFindingType) => void;
}

function SummaryStatsBar(props: SummaryStatsBarProps) {
    const { result, getFindingTypeColor, translateString, selectedFindingType, onFindingTypeClick } = props;

    const countByFindingType = (findingType: BestPracticeCheckFindingType) => result.findings.filter((finding) => finding.findingType === findingType).length;

    const findingTypeItems = [
        {
            label: translateString("fulfilled"),
            count: countByFindingType(BestPracticeCheckFindingType.FullCompliance),
            findingType: BestPracticeCheckFindingType.FullCompliance,
        },
        {
            label: translateString("partiallyFulfilled"),
            count: countByFindingType(BestPracticeCheckFindingType.PartialCompliance),
            findingType: BestPracticeCheckFindingType.PartialCompliance,
        },
        {
            label: translateString("missingElements"),
            count: countByFindingType(BestPracticeCheckFindingType.MissingElement),
            findingType: BestPracticeCheckFindingType.MissingElement,
        },
    ];

    return (
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
            <DotLegalHeader headerStyle={"small"} fontWeight={400} marginBottom={0}>
                {translateString("numberOfBestPracticeAnalyzeFindings", { count: result.findings.length }).toLowerCase()}
            </DotLegalHeader>
            <Divider orientation="vertical" sx={(theme) => ({ borderColor: theme.palette.grey[400], height: 18 })} />
            {findingTypeItems.map((item) => (
                <Box
                    key={item.findingType}
                    onClick={() => onFindingTypeClick(item.findingType)}
                    sx={{
                        display: "flex",
                        gap: 0.5,
                        alignItems: "center",
                        cursor: "pointer",
                        opacity: selectedFindingType !== undefined && selectedFindingType !== item.findingType ? 0.4 : 1,
                        transition: "opacity 0.2s",
                        "&:hover": { opacity: selectedFindingType !== undefined && selectedFindingType !== item.findingType ? 0.6 : 1 },
                    }}
                >
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: getFindingTypeColor(item.findingType) }} />
                    <DotLegalHeader headerStyle={"small"} fontWeight={selectedFindingType === item.findingType ? 700 : 400} marginBottom={0}>
                        {item.label}: {item.count}
                    </DotLegalHeader>
                </Box>
            ))}
        </Box>
    );
}

export default SummaryStatsBar;
